import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InvoiceList';
import InvoiceList from './InvoiceList';
import { StoreState } from 'src/store/reducers';
import { getInvoices } from 'src/store/actions/invoice-actions';
import { getStudents } from 'src/store/actions/student-actions';
import { QueryParams } from 'src/types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.invoices.data,
        inProgress: state.invoices.inProgress,
        students: state.students.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) =>
            dispatch(
                getInvoices({
                    ...params,
                    notTotal: true,
                    filters: {
                        ...params.filters,
                        'provider.id': ownProps.provider?.id,
                    },
                }),
            ),
        getStudents: (params: QueryParams) => dispatch(getStudents(params)),
    };
}

const InvoiceListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoiceList);

export default InvoiceListScreen;
